var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zm-button',{attrs:{"data-testid":"checkout-button-479","data-url":_vm.targetUrl,"size":"large","type":"primary","round":""},on:{"click":_vm.goUser}},[_vm._v(_vm._s(_vm.ctaName))])}
var staticRenderFns = []

export { render, staticRenderFns }